import React from 'react';
import { MapItemList } from '../../components/graphic/Index';
import styles from './graphics.module.scss';

// Internal state for the component
interface State {}

// Normal properties for the component
interface OwnProps {}

// combine them together
type Props = OwnProps;

class GraphicPage extends React.Component<Props, State> {
	container: string = 'floorPlan';

	constructor(prop) {
		super(prop);
	}

	componentDidMount() {
		init_CADViewer(this.container);
	}

	componentDidCatch(error, errorInfo) {
		console.log(error, errorInfo);
	}

	render() {
		return (
			<div className={styles.container}>
				<div>
					<MapItemList />
				</div>
				<div id={this.container}></div>
			</div>
		);
	}
}

export { GraphicPage };
